import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0E0E0E] text-white flex items-center justify-center">
        <div className="font-mono text-sm animate-pulse">Loading...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
}
